var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0002 40.9223C33.3466 40.9223 40.9233 33.3456 40.9233 23.9992C40.9233 14.6529 33.3466 7.07617 24.0002 7.07617C14.6539 7.07617 7.07715 14.6529 7.07715 23.9992C7.07715 33.3456 14.6539 40.9223 24.0002 40.9223Z",
    stroke: "#6D6E71",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3848 20.1525C19.3848 17.5371 21.3848 15.5371 24.0002 15.5371C26.6155 15.5371 28.6155 17.5371 28.6155 20.1525C28.6155 22.7679 26.6155 24.7679 24.0002 24.7679V29.3833",
    stroke: "#6D6E71",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0004 31.6914C23.0773 31.6914 22.4619 32.3068 22.4619 33.2299C22.4619 34.1529 23.0773 34.7683 24.0004 34.7683C24.9235 34.7683 25.5388 34.1529 25.5388 33.2299C25.5388 32.3068 24.9235 31.6914 24.0004 31.6914Z",
    fill: "#6D6E71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.3c1e6933f5931b72fdec8c6a028acdaa.svg";
export { ForwardRef as ReactComponent };